/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import classNames from 'classnames';
import Body, { Color as BodyColor } from 'components/Typography/Body';
import ErrorMessage from 'components/Typography/ErrorMessage';
import DatePicker from 'components/Common/DatePicker';

export const LabelPosition = Object.freeze({
  Top: 'top',
  Left: 'left',
});

export const Color = Object.freeze({
  Black: 'black',
  Gray: 'gray',
});

const FormControlDatePicker = ({
  name,
  label,
  labelClassName,
  placeholder,
  defaultValue,
  className,
  disabled,
  readOnly,
  color,
  showTimeSelect,
  onChangeManual,
  isUTC,
  testId,
}) => {
  const {
    formState: { errors },
    control,
    setValue: setFormValue,
  } = useFormContext();
  const error = errors[name];

  useEffect(() => {
    if (defaultValue) {
      setFormValue(name, defaultValue);
    }
  }, [setFormValue, name, defaultValue]);

  return (
    <div className={classNames(className, 'mb-5')}>
      {label && (
        <Body
          color={BodyColor.Black}
          className={classNames(labelClassName, 'w-fit pb-2.5 text-sm')}
        >
          {label}
        </Body>
      )}
      <div>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({
            field: { onChange, onBlur, value, defaultValue: dateValue },
          }) => (
            <DatePicker
              onChange={(...args) => {
                onChangeManual?.(...args);
                onChange(...args);
              }}
              onBlur={onBlur}
              date={value}
              placeholder={placeholder}
              defaultValue={defaultValue || dateValue}
              disabled={disabled}
              readOnly={readOnly}
              error={!!error}
              color={color}
              showTimeSelect={showTimeSelect}
              isUTC={isUTC}
              testId={testId}
            />
          )}
        />
        {error && <ErrorMessage>{error.message}</ErrorMessage>}
      </div>
    </div>
  );
};

FormControlDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  defaultValue: PropTypes.instanceOf(Date),
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  color: PropTypes.oneOf(Object.values(Color)),
  showTimeSelect: PropTypes.bool,
  onChangeManual: PropTypes.func,
  isUTC: PropTypes.bool,
  testId: PropTypes.string,
};

FormControlDatePicker.defaultProps = {
  label: null,
  placeholder: 'MM/DD/YYYY',
  className: '',
  labelClassName: '',
  defaultValue: null,
  disabled: false,
  readOnly: false,
  color: Color.Gray,
  showTimeSelect: false,
  onChangeManual: null,
  isUTC: false,
  testId: null,
};

export default FormControlDatePicker;
